<template>
  <ul class="nav-container">
    <li @click="closeAllMenus">
      <router-link to="/" :class="{ active: page === 'AboutUs' }"
        >首頁</router-link
      >
    </li>
    <!-- <li>
      <router-link
        to="/features/suck-customer-tool"
        :class="{ 'active': page === 'Features' }"
        >功能介紹</router-link
      >
    </li> -->
    <li class="nest flex" @click="openMenu('solution')">
      <div class="flex" :class="{ active: page === 'Features' }">
        功能介紹
        <!-- <img
          class="ml-2 w-[12px]"
          src="@/assets/icon/arrow-down.svg"
          alt="arrow-down"
        /> -->
      </div>
      <ul
        class="nest-container grid-rows-6"
        v-if="desktopNest.solution"
        @mouseleave="handleMouseLeave"
        @click="handleMouseLeave"
      >
        <!-- <li
        :class="{
            selected:
              page === 'Features' && featuresTab === 'suck-customer-tool',
          }"
        >
          <router-link to="/features/suck-customer-tool">吸客神器</router-link>
        </li>
        <li
          :class="{
            selected:
            page === 'Features' && featuresTab === 'remain-customer-tool',
          }"
          >
          <router-link to="/features/remain-customer-tool"
          >留客法寶</router-link
          >
        </li>
        <li
        :class="{
            selected: page === 'Features' && featuresTab === 'shop-manage-tool',
          }"
        >
          <router-link to="/features/shop-manage-tool">管店專家</router-link>
        </li> -->
        <li
          :class="{
            selected: page === 'Features' && featuresTab === 'reservations',
          }"
        >
          <router-link to="/features/reservations">即時預約管理</router-link>
        </li>
        <li
          :class="{
            selected:
              page === 'Features' && featuresTab === 'device-space-management',
          }"
        >
          <router-link to="/features/device-space-management"
            >共享空間設備</router-link
          >
        </li>
        <li
          :class="{
            selected: page === 'Features' && featuresTab === 'line-recruit',
          }"
        >
          <router-link to="/features/line-recruit">多元拓展新客</router-link>
        </li>
        <li
          :class="{
            selected:
              page === 'Features' && featuresTab === 'grasp-repurchasers',
          }"
        >
          <router-link to="/features/grasp-repurchasers"
            >熟客持續回流</router-link
          >
        </li>
        <li
          :class="{
            selected: page === 'Features' && featuresTab === 'promotions',
          }"
        >
          <router-link to="/features/promotions">促購行銷活動</router-link>
        </li>
        <li
          :class="{
            selected: page === 'Features' && featuresTab === 'store-management',
          }"
        >
          <router-link to="/features/store-management"
            >連鎖店務管理</router-link
          >
        </li>
        <li
          :class="{
            selected: page === 'Features' && featuresTab === 'payment-method',
          }"
        >
          <router-link to="/features/payment-method">多元支付</router-link>
        </li>
        <li
          :class="{
            selected:
              page === 'Features' && featuresTab === 'e-commerce-business',
          }"
        >
          <router-link to="/features/e-commerce-business">社群電商</router-link>
        </li>
      </ul>
    </li>

    <li class="nest flex" @click="openMenu('industrial')">
      <div class="flex" :class="{ active: page === 'IndustrialApplication' }">
        產業應用
      </div>
      <ul
        class="nest-container grid-rows-6"
        v-if="desktopNest.industrial"
        @mouseleave="handleMouseLeave"
        @click="handleMouseLeave"
      >
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' && featuresTab === 'nail-salon',
          }"
        >
          <router-link to="/industrial-application/nail-salon"
            >美甲業</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'eyelash-salon',
          }"
        >
          <router-link to="/industrial-application/eyelash-salon"
            >美睫業</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'beauty-salon',
          }"
        >
          <router-link to="/industrial-application/beauty-salon"
            >美容業</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' && featuresTab === 'SPA-massage',
          }"
        >
          <router-link to="/industrial-application/SPA-massage"
            >Spa 按摩</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' && featuresTab === 'hair-salon',
          }"
        >
          <router-link to="/industrial-application/hair-salon"
            >美髮沙龍</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'teeth-whitening',
          }"
        >
          <router-link to="/industrial-application/teeth-whitening"
            >美學牙科</router-link
          >
        </li>

        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'aesthetic-medicine',
          }"
        >
          <router-link to="/industrial-application/aesthetic-medicine"
            >醫美診所</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'mental-therapy',
          }"
        >
          <router-link to="/industrial-application/mental-therapy"
            >心靈療癒</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' && featuresTab === 'stay-fit',
          }"
        >
          <router-link to="/industrial-application/stay-fit"
            >體態雕塑</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' && featuresTab === 'yoga-course',
          }"
        >
          <router-link to="/industrial-application/yoga-course"
            >瑜珈美學</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'eyebrow-tattoo',
          }"
        >
          <router-link to="/industrial-application/eyebrow-tattoo"
            >紋繡霧眉</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'makeup-artist',
          }"
        >
          <router-link to="/industrial-application/makeup-artist"
            >彩妝服務業</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'beautiful-breast',
          }"
        >
          <router-link to="/industrial-application/beautiful-breast"
            >美胸業</router-link
          >
        </li>
        <li
          :class="{
            selected:
              page === 'IndustrialApplication' &&
              featuresTab === 'hair-removal',
          }"
        >
          <router-link to="/industrial-application/hair-removal"
            >除毛業</router-link
          >
        </li>
      </ul>
    </li>
    <li @click="closeAllMenus">
      <router-link
        :to="{ name: 'Blog', params: { cate: '應用案例' } }"
        :class="{ active: isApplicationCase }"
      >
        應用案例
      </router-link>
    </li>
    <li @click="closeAllMenus">
      <router-link
        to="/plan-content"
        :class="{ active: page === 'PlanContent' }"
      >
        方案內容
      </router-link>
    </li>
    <!-- <li>
      <router-link
        to="/sms-reservation"
        :class="{ active: page === 'SMSReservation' }"
        >簡訊預約</router-link
      >
    </li> -->
    <li @click="closeAllMenus">
      <router-link
        to="/media-marketing"
        :class="{ active: page === 'MediaMarketing' }"
        >媒體行銷</router-link
      >
    </li>
    <li class="nest flex" @click="openMenu('ecoSystem')">
      <div class="flex" :class="{ active: page === 'Columns' }">美業生態圈</div>
      <ul
        class="nest-container grid-rows-2"
        v-if="desktopNest.ecoSystem"
        @mouseleave="handleMouseLeave"
        @click="handleMouseLeave"
      >
        <li>
          <a href="https://www.beautinq.com/partner">生態圈夥伴</a>
        </li>
        <li
          :class="{
            selected: page === 'Columns',
          }"
        >
          <router-link to="/columns">合作專欄</router-link>
        </li>
      </ul>
    </li>
    <li class="nest flex" @click="openMenu('resource')">
      <!-- <router-link
        :to="{ name: 'Blog' }"
        :class="{ active: blogRelatedPages.includes(page) && !isApplicationCase }"
      >
        美業密技
      </router-link> -->
      <div
        class="flex"
        :class="{ active: page === 'Blog' && !isApplicationCase }"
      >
        資源與活動
      </div>
      <ul
        class="nest-container grid-rows-3"
        v-if="desktopNest.resource"
        @mouseleave="handleMouseLeave"
        @click="handleMouseLeave"
      >
        <li
          :class="{
            selected: page === 'Blog',
          }"
        >
          <router-link to="/blog">部落格</router-link>
        </li>
        <li>
          <a target="_blank" href="https://linktr.ee/wishmobile_projects"
            >政府補助</a
          >
        </li>
        <li>
          <a
            target="_blank"
            href="https://www.accupass.com/organizer/detail/2302140358578555600450"
            >講座活動</a
          >
        </li>
      </ul>
    </li>

    <!-- <li>
      <router-link
        to="/tutorial"
        :class="{ 'active': tutorialRelatedPages.includes(page) }"
      >
        新手教室
      </router-link>
    </li> -->
    <li>
      <button @click="$emit('toForm')">聯絡我們</button>
    </li>
  </ul>
</template>

<script setup>
import { includes } from 'lodash-es'
import { computed, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'

defineEmits(['close', 'toForm'])

defineProps({
  blogRelatedPages: {
    type: Array,
    default: () => [],
  },
  columnsRelatedPages: {
    type: Array,
    default: () => [],
  },
  tutorialRelatedPages: {
    type: Array,
    default: () => [],
  },
})

const desktopNest = reactive({
  solution: false,
  industrial: false,
  ecoSystem: false,
  resource: false,
})

const route = useRoute()

const page = computed(() => route.name)
const isApplicationCase = computed(() =>
  includes(decodeURIComponent(route.path), '應用案例'),
)
const featuresTab = computed(() => {
  return route.params.name
})

const openMenu = (menu) => {
  closeAllMenus()
  desktopNest[menu] = !desktopNest[menu]
}

const closeAllMenus = () => {
  Object.keys(desktopNest).forEach((key) => {
    desktopNest[key] = false
  })
}

const handleMouseLeave = () => {
  closeAllMenus()
}
onMounted(() => {
  document.addEventListener('click', (event) => {
    // 檢查點擊是否在導航選單區域外
    const navbar = document.querySelector('.nav-container')
    if (navbar && !navbar.contains(event.target)) {
      closeAllMenus()
    }
  })
})
</script>

<style scoped lang="postcss">
.nav-container {
  @apply grid grid-flow-col items-center <laptop:hidden;
  @apply gap-4;
}

.mobile-nav-container {
  @apply absolute top-[72px] left-0 right-0 py-[12px];
  @apply bg-white text-left  text-secondary-dark;
  z-index: 5;
}

.router-link-container {
  @apply px-[28px] py-[9px];
}

.nest {
  @apply cursor-pointer whitespace-nowrap;
  ul {
    @apply pt-[9px];
  }
}
.nest-container {
  @apply absolute top-[75px] z-5 bg-white rounded-sm text-left !pt-0 shadow-lg grid;
  /* grid-template-rows: repeat(5,1fr); */
  grid-auto-flow: column;

  > li {
    @apply hover:bg-primary-100 hover:text-white;
    a {
      @apply py-[9px] px-[12px] block;
    }
  }
}

.selected {
  @apply relative text-white;
}
.active {
  @apply text-primary-100 relative;
}

.active::after {
  content: '';
  @apply absolute bottom-[-5px] left-0 right-0 left-0  h-[2px]  bg-primary-100;
}

.selected::before {
  content: '';
  @apply bg-primary-100 w-full h-full absolute left-0 right-0 top-0 bottom-0;
  z-index: -1;
}

button {
  @apply rounded-full bg-[#52c8b9] px-[20px] py-[10px] text-[15px] text-white;
}
</style>
